import React, { useEffect, useState } from 'react';
import Iframe from 'react-iframe';
import AuthService from '../../services/auth.service';
import { Spinner, Alert } from '../../services/notiflix.service';
import { updateAuthUser } from '../../actions/auth';
import { useSelector, useDispatch } from 'react-redux';
import { CrossSignIcon } from './IconProvider';
const EsignaturesPop = ({
  modelClose,
  type,
  project_id,
  declineModelClose,
  isSignedPltformAgreement,
  setSignedPltformAgreement,
  setIsOpenAggrement = null,
  setIsProjectAgreement,
}) => {
  const dispatch = useDispatch();
  const { user: _authUser } = useSelector((state) => state.auth);
  const [platformAgreement, setPlatformAgreement] = useState(null);
  useEffect(() => {
    generateAgreement();
  }, []);

  const generateAgreement = async () => {
    Spinner.show();
    try {
      const formData = { type, project_id };
      let resp = await AuthService.initiateAgreement(formData);

      if (resp.status === 'failure') {
        Spinner.hide();
        declineModelClose();
        Alert.error(resp.message);
        return false;
      }

      setPlatformAgreement(resp?.data);
      if (
        type === 'project' &&
        setIsProjectAgreement & (resp?.data?.agreement_status === 1)
      ) {
        setIsProjectAgreement(true);
      }

      checkAgreementSignStatus(resp?.data?.id);
    } catch (error) {
      Spinner.hide();
      declineModelClose();
      Alert.error(error.message);
      return false;
    }
  };

  const checkAgreementSignStatus = async (id) => {
    try {
      Spinner.hide();
      const formData = {
        id: id,
      };
      let resp = await AuthService.eSignaturesAgreementStatus(formData);
      if (resp.status === 'failure') {
        Spinner.hide();
        declineModelClose();
        Alert.error(resp.message);
        return false;
      }
      if (resp.data?.agreement_status === 0) {
        setTimeout(() => {
          checkAgreementSignStatus(id);
        }, 3000);
        return false;
      }

      let authUser = { ..._authUser };
      if (type === 'platform') {
        authUser['platform_agreement_status'] = resp.data?.agreement_status;
        await Promise.resolve(dispatch(updateAuthUser(authUser)));
      }

      if (setSignedPltformAgreement) {
        setSignedPltformAgreement(!isSignedPltformAgreement);
      }

      setTimeout(() => {
        if (resp.data?.agreement_status === 1) {
          setTimeout(() => {
            if (
              (type === 'project' || type === 'platform') &&
              setIsOpenAggrement
            ) {
              setIsOpenAggrement(true);
            }
          }, 1000);
          modelClose(true);
        } else if (resp.data?.agreement_status === 2) {
          declineModelClose();
        }
      }, 2000);
    } catch (error) {
      Spinner.hide();
      declineModelClose();
      Alert.error(error.message);
      return false;
    }
  };
  return (
    <>
      <div className="justify-center overflow-x-hidden overflow-y-auto fixed items-center flex inset-0 z-50 outline-none focus:outline-none">
        <div className="py-20 px-10 bg-white rounded-lg relative">
          <button
            className="p-1 ml-auto bg-transparent border-0 text-black text-3xl leading-none font-semibold outline-none focus:outline-none z-10 flex justify-center items-center absolute right-0 top-0"
            onClick={() => declineModelClose()}
          >
            <span className="bg-transparent text-black w-10 h-8 dark:bg-slate-400 dark:rounded-md flex justify-center items-center outline-none focus:outline-none">
              <CrossSignIcon _bold={true} />
            </span>
          </button>

          <Iframe
            url={platformAgreement?.agreement_url}
            // width="800px"
            className="md:w-[800px] h-[500px] sm:w-full block relative"
          />
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
};
export default EsignaturesPop;
